import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import DiagsPresence from './components/DiagsPresence';
import DiagsPartner from './components/DiagsPartner';
import DiagsImport from './components/DiagsImport';

import { updateStep } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const Diagnostics = () => {
  const { photoPacks: { can_use_lightshop_pack_max } } = useSelector((state) => state.sellerPhotoMeetings);
  const [hasDiags, setHasDiags] = useState(null);
  const [needsDiags, setNeedsDiags] = useState(null);
  const [importDiags, setImportDiags] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (hasDiags === true) setNeedsDiags(null);
    if (hasDiags === false) {
      setImportDiags(null);
      if (can_use_lightshop_pack_max) dispatch(updateStep('PackMax'));
    }
  }, [hasDiags]);

  useEffect(() => {
    if (importDiags === true) dispatch(updateStep('DiagsUploader'));
    if (importDiags === false) dispatch(updateStep('PhotoMeeting'));
  }, [importDiags]);

  useEffect(() => {
    if (needsDiags === null) return;
    
    dispatch(updateStep(can_use_lightshop_pack_max ? 'PackMax' : 'PhotoMeeting'));
  }, [needsDiags]);

  return (
    <div className='flex flex-col gap-6 text-ih-indigo'>
      <DiagsPresence hasDiags={hasDiags} setHasDiags={setHasDiags} />
      <DiagsPartner hasDiags={hasDiags} needsDiags={needsDiags} setNeedsDiags={setNeedsDiags} />
      <DiagsImport hasDiags={hasDiags} importDiags={importDiags} setImportDiags={setImportDiags} />
    </div>
  )
}

export default Diagnostics;
